var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91606 8.32149L9.93408 8.30347M10.7098 6.02926L10.7278 6.01125M12.5864 7.65978L12.6044 7.64176M15.6718 15.6718L17.2092 17.2092M11.4441 16.0562L17.0401 20.474C18.0132 21.2423 19.4072 21.1605 20.2839 20.2839M16.0562 11.4441L20.474 17.0401C21.2423 18.0132 21.1605 19.4072 20.2839 20.2839M20.2839 20.2839L21.5 21.5M14.1345 4.91037C16.6816 7.45754 16.6816 11.5873 14.1345 14.1345C11.5873 16.6816 7.45754 16.6816 4.91037 14.1345C2.36321 11.5873 2.36321 7.45754 4.91037 4.91037C7.45754 2.36321 11.5873 2.36321 14.1345 4.91037Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.8b90ceb4ef8699d86e8aa68287f3c2d7.svg";
export { ForwardRef as ReactComponent };